import axios from "axios"
import { BASE_URL } from "../constants/constants"

import Cookies from "js-cookie";


axios.defaults.baseURL = BASE_URL

const http = axios.create({
    baseURL: BASE_URL,
    timeout: 120000,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // 'Access-Control-Allow-Origin': '*',
    }
})

http.interceptors.request.use(
    (config) => {
        const tokenVal = Cookies.get('token');
        config.baseURL = BASE_URL
        if (tokenVal) {
            config.headers.Authorization = `Bearer ${tokenVal}`
        }
        return config
    }
)

http.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log('error - ', error)
        if (error.response && (error.response.status === 403 || error.response.status === 401)) {
            Cookies.remove("role");
            Cookies.remove("token");
            window.dispatchEvent(new Event("auth-error"));
        }
        return Promise.reject(error);
    }
)

export default http